// Static storytelling content for AJDR Factory

export const IMAGES = {
  heroCrew: "/img/hero.jpg",
  heroStreet: "/img/blockparty.jpg",
  mc: "/img/mc.jpg",
  blockparty: "/img/blockparty.jpg",
  battle: "/img/battle.jpg",
  hiphop: "/img/hiphop.jpg",
  breakStairs: "/img/break.jpg",
  breakStage: "/img/battle.jpg",
  popping: "/img/popping.jpg",
  locking: "/img/locking.jpg",
  house: "/img/house.jpg",
  heels: "/img/heels.jpg",
  kpop: "/img/kpop.jpg",
  graffMonsters: "/img/graff.jpg",
  graffFace: "/img/graff.jpg",
  graffTunnel: "/img/graff.jpg",
  dj1: "/img/dj.jpg",
  djVinyl: "/img/mc.jpg",
  djController: "/img/dj.jpg",
  studioGroup: "/img/studio.jpg",
  stageYellow: "/img/heels.jpg",
  stageGroup: "/img/stage.jpg",
  stageEmotion: "/img/stage.jpg",
  crewWomen: "/img/locking.jpg",
  crewGray: "/img/popping.jpg",
  warehouse: "/img/blockparty.jpg",
  beatController: "/img/dj.jpg",
};

export const STATS = [
  { value: "1996", label: "Année de création" },
  { value: "30+", label: "Ans de culture urbaine" },
  { value: "9", label: "Profs & mentors" },
  { value: "2", label: "Salles + 1 studio" },
];

export const DISCIPLINES = [
  { name: "Hip-Hop", tag: "Danse", img: IMAGES.hiphop,
    text: "Né dans le Bronx à la fin des années 70, le Hip-Hop est le socle du mouvement : groove, freestyle et énergie brute. Le langage universel de la rue." },
  { name: "Breakdance", tag: "Danse", img: IMAGES.breakStairs,
    text: "Le B-boying, discipline olympique. Top rocks, footworks, freezes et power moves : la puissance, l'équilibre et le style à même le sol." },
  { name: "Popping", tag: "Danse", img: IMAGES.popping,
    text: "Californie, années 70. Contractions musculaires saccadées, robots et waves. Le funk fait vibrer chaque muscle sur le beat." },
  { name: "Locking", tag: "Danse", img: IMAGES.locking,
    text: "Le funk le plus solaire : arrêts nets, pointés, claps et sourire. Don Campbell a inventé ce style plein de fun et de charisme." },
  { name: "House", tag: "Danse", img: IMAGES.house,
    text: "Chicago & New York. Jackin', footwork rapide et lofting sur des rythmes house à 4 temps. La liberté, la transe et la connexion à la musique." },
  { name: "Heels", tag: "Danse", img: IMAGES.heels,
    text: "L'affirmation de soi en talons. Puissance, féminité et confiance : un style qui libère le corps et l'attitude sur scène." },
  { name: "K-Pop", tag: "Danse", img: IMAGES.kpop,
    text: "La vague coréenne : chorégraphies synchronisées, précision millimétrée et esprit de groupe. La performance dans toute sa rigueur." },
  { name: "Graff", tag: "Art visuel", img: IMAGES.graffMonsters,
    text: "Notre Graff Park : lettrages, personnages et fresques. La bombe comme pinceau, le mur comme toile. L'expression brute des rues." },
  { name: "Beatmaking / DJing", tag: "Son", img: IMAGES.dj1,
    text: "Studio dédié : MAO, sampling, scratch et mix. On fabrique les instrus qui font bouger les corps et vibrer le quartier." },
  { name: "Chant / MCing", tag: "Voix", img: IMAGES.mc,
    text: "Poser sa voix, écrire ses textes, prendre le micro. Le MC raconte, le chant libère. La parole comme arme et comme refuge." },
];

export const TEACHERS = [
  { name: "Djamel", role: "Directeur artistique · Hip-Hop / House", initials: "DK", color: "#DD3733" },
  { name: "Elie", role: "Popping / Boogaloo", initials: "EL", color: "#8E1F1D" },
  { name: "Mika", role: "Hip-Hop Newstyle", initials: "MK", color: "#E8E4DC" },
  { name: "Tolo", role: "Breakdance / B-boying", initials: "TO", color: "#DD3733" },
  { name: "Jeremy", role: "Locking / Funk styles", initials: "JR", color: "#8E1F1D" },
  { name: "Stéphane", role: "Beatmaking / Chant / MAO", initials: "ST", color: "#E8E4DC" },
  { name: "Farah", role: "Heels / Choré", initials: "FA", color: "#DD3733" },
  { name: "Théo", role: "Graff / Arts visuels", initials: "TH", color: "#8E1F1D" },
  { name: "Julie", role: "K-Pop / Danse ados", initials: "JU", color: "#E8E4DC" },
];

export const TIMELINE = [
  { year: "1996", title: "La naissance", text: "L'Association des Jeunes Danseurs de Rue voit le jour à Albi. Une poignée de passionnés, un local, une vision : offrir un refuge à la culture hip-hop." },
  { year: "2005", title: "Le centre grandit", text: "Ouverture d'une seconde salle et structuration de l'école. Les cours se multiplient, la famille s'agrandit." },
  { year: "2014", title: "Le studio & le graff park", text: "Un studio d'enregistrement et un graff park voient le jour. La culture urbaine se vit dans toutes ses dimensions." },
  { year: "2020", title: "La Compagnie Recto-Verso", text: "La compagnie professionnelle prend son envol et porte les créations de l'AJDR sur les scènes." },
  { year: "2026", title: "Aujourd'hui", text: "Un écosystème complet : 2 salles, 1 studio, 1 graff park, 1 café hip-hop. Un lieu de vie, de création et de transmission." },
];

export const EVENTS = [
  { name: "BLOCK PARTY ORIGINAL", tag: "Événement phare", img: IMAGES.blockparty,
    text: "Le rendez-vous incontournable : battles, cyphers, DJ sets et fresques live. Toute la culture réunie le temps d'une fête." },
  { name: "ALL4ALL", tag: "Rencontre", img: IMAGES.battle,
    text: "Un événement fédérateur où toutes les disciplines se croisent. Danse, graff, son : l'esprit de partage à l'état pur." },
];

export const VALUES = [
  { icon: "Users", title: "Une famille", text: "Ici, on ne vient pas juste danser. On appartient à une communauté qui te soutient, t'écoute et t'élève." },
  { icon: "Shield", title: "Un refuge", text: "Un lieu sûr pour les jeunes, où chacun peut s'exprimer, se construire et trouver sa place loin des jugements." },
  { icon: "Sparkles", title: "La confiance", text: "L'expression corporelle et artistique comme moteur de la confiance en soi et de l'acceptation de soi." },
  { icon: "Flame", title: "La culture", text: "Transmettre l'histoire et les codes du Hip-Hop : le respect, le partage, la créativité et l'authenticité." },
];

export const PROJECTS = [
  {
    key: "un-mot-un-geste", name: "Un mot, un geste", theme: "Culture & santé", sub: "Handicap et dépendance",
    img: "/img/projets/un-mot-un-geste.jpg",
    intro: "Accompagner les personnes atteintes de surdité à travers la culture Hip-Hop.",
    text: "Accompagner, c'est se joindre à quelqu'un, l'aider, le guider — mais aussi comprendre la personne, la pathologie, et s'adapter. Avec les institutions spécialisées (MECS, ITEP, IME, CESDA…), nous rassemblons des jeunes venus d'horizons différents pour échanger sur leurs savoir-faire et savoir-être, briser les représentations et travailler l'image de soi. La pratique d'un art partagé est le meilleur moyen de se rencontrer.",
    partners: ["MECS", "ITEP", "IME", "CESDA"],
  },
  {
    key: "couleurs-reinsertion", name: "Couleurs et réinsertion", theme: "Culture & justice", sub: "Maison d'arrêt d'Albi",
    img: "/img/projets/couleurs-reinsertion.jpg",
    intro: "Des ateliers artistiques au cœur de la maison d'arrêt d'Albi.",
    text: "Des ateliers d'initiation qui donnent aux détenus le goût de l'art : s'accrocher à quelque chose, renouer avec le monde extérieur, s'investir dans une démarche artistique au sein même de la prison et devenir plus que spectateurs. Ces séances réinscrivent aussi dans un quotidien — être à l'heure, retrouver un rythme. Un projet mené en partenariat avec la Scène Nationale, pensé pour durer.",
    partners: ["Scène Nationale d'Albi", "Maison d'arrêt"],
  },
  {
    key: "tous-en-piste", name: "Tous en piste", theme: "Culture & politique de la ville", sub: "Festival d'Avignon",
    img: "/img/projets/tous-en-piste.jpg",
    intro: "Sortir les ados de leur quotidien et les emmener jusqu'aux rues d'Avignon.",
    text: "La danse comme outil de médiation : les élèves présentent le travail de l'année lors des spectacles de rue du Festival d'Avignon, échangent avec les artistes et le public après chaque représentation. Le projet favorise l'autonomie, apprend à s'organiser en communauté et permet aux jeunes de gagner leurs vacances par leurs propres moyens.",
    partners: ["Festival d'Avignon"],
  },
  {
    key: "autre-cote-perif", name: "De l'autre côté du périph'", theme: "Culture & politique de la ville", sub: "Mobilité & ouverture",
    img: "/img/projets/autre-cote-perif.jpg",
    intro: "Franchir les frontières invisibles des quartiers par la danse.",
    text: "Un projet de mobilité culturelle : préparer une création tout au long de l'année, puis la porter hors du quartier, à la rencontre d'autres publics et d'autres artistes. Les jeunes gagnent en autonomie, apprennent la vie de groupe et découvrent qu'ils ont leur place partout — de l'autre côté du périph'.",
    partners: ["Quartiers d'Albi"],
  },
  {
    key: "caravane", name: "Caravane des Quartiers", theme: "Culture & politique de la ville", sub: "Événement itinérant",
    img: "/img/projets/caravane.jpg",
    intro: "Comme un cirque, la caravane Hip-Hop se déplace de quartier en quartier.",
    text: "Spectacle de qualité, initiations et mise en scène de ce que les habitants ont appris : occuper les espaces interstitiels, dynamiser les quartiers populaires et lancer une invitation au spectacle vivant. Un moment convivial et intergénérationnel qui anime la vie locale, avec un objectif : permettre aux habitants d'être acteurs dans leur propre quartier.",
    partners: ["Habitants", "Quartiers populaires"],
  },
];
